import {
    Curves,
    GameObjects,
    Input,
    Physics,
    Scene,
    Tilemaps,
    Types} from "phaser";

import {Coin} from "../animations/Coin";
import {Dude} from "../animations/Dude";
import {BaseAnimation} from "../animations/BaseAnimation";
import {GameMap} from "../map/GameMap";
import {Audio} from "../audio/Audio";
import {Constants} from "../Constants";
import {Loading} from "../animations/Loading";
import {Directions} from "../Directions";


const sceneConfig: Phaser.Types.Scenes.SettingsConfig = {
    key: 'MainScene',
    pack: <any>{
        files: [
            {type: 'image', key: 'loadingText', url: 'assets/loading/testo.png'},
            {type: 'image', key: 'loading1', url: 'assets/loading/1.png'},
            {type: 'image', key: 'loading2', url: 'assets/loading/2.png'},
            {type: 'image', key: 'loading3', url: 'assets/loading/3.png'},
            {type: 'image', key: 'loading4', url: 'assets/loading/4.png'},
            {type: 'image', key: 'loading5', url: 'assets/loading/5.png'},
            {type: 'image', key: 'loading6', url: 'assets/loading/6.png'},
            {type: 'image', key: 'loading7', url: 'assets/loading/7.png'},
            {type: 'image', key: 'loading8', url: 'assets/loading/8.png'},
            {type: 'image', key: 'loading9', url: 'assets/loading/9.png'},
            {type: 'image', key: 'loading10', url: 'assets/loading/10.png'},
            {type: 'image', key: 'loading11', url: 'assets/loading/11.png'},
            {type: 'image', key: 'loading12', url: 'assets/loading/12.png'}
        ]
    }
};


export class MainScene extends Scene
{
    /**
     * I metodi vengono chiamati in questo ordine
     * 1) init
     * 2) preload
     * 3) create
     * 4) update
     * */

    private createStarted: boolean = false;
    private updateStarted: boolean = false;

    private score: number = 0;
    private scoreTextObj: GameObjects.Text;
    private wonMsg: GameObjects.Text;
    private endMsg: Physics.Arcade.Sprite;
    private dude: GameObjects.Sprite;
    private flag: GameObjects.Sprite;
    private timeLines: number = 0;
    private timer: number = 0;

    private cursors: any;
    private jumpButton: any;
    private readonly DUDE: string = "dude";
    private coin: BaseAnimation;
    private dudeAnimation: BaseAnimation;
    private loadingAnimation: BaseAnimation;

    private onLadder: boolean = false;
    private onDoor: boolean = false;


    private map: GameMap;
    private linesLayer: Tilemaps.ObjectLayer;
    private flagLayer: Tilemaps.ObjectLayer;
    private coinLayer: Tilemaps.ObjectLayer;
    private coins: Physics.Arcade.StaticGroup;
    private linesArray: Array<Physics.Arcade.Sprite>;
    private airplane: GameObjects.PathFollower;
    private coinAirplane: GameObjects.PathFollower;

    private joystick: any; // non può avere un tipo definito, perché viene riassegnato in caso di mobile
    private airplaneHasGone: boolean = false;

    private Sounds;

    constructor() {
        super(sceneConfig);
    }

    public init(): void
    {
        this.coin = new Coin(this);
        this.dudeAnimation = new Dude(this);
        this.map = new GameMap(this);
        this.loadingAnimation = new Loading(this);
        this.linesArray = new Array<Physics.Arcade.Sprite>();
    }


    private createVirtualJoystick(): void
    {
        let plugin = <any> this.plugins.get("rexVirtualJoyStick");
        let width: number = Constants.DEFAULT_WIDTH;
        let height: number = Constants.DEFAULT_HEIGHT;

        let circle = this.add.circle(0, 0, 80, 0x888888, 0.3);
        circle.setStrokeStyle(2,0xcccccc);

        this.joystick = plugin.add(this, {
            x: width*0.1,
            y: height - height*0.2,
            radius: 80,
            base: circle,
            thumb: this.add.circle(0, 0, 45, 0x000000, 0.8),
            dir: '4dir',   // 'up&down'|0|'left&right'|1|'4dir'|2|'8dir'|3
            forceMin: 16,
            enable: true
        });

        this.cursors = this.joystick.createCursorKeys();
    }

    private createMobileJumpButton(): void
    {
        let width: number = Constants.DEFAULT_WIDTH;
        let height: number = Constants.DEFAULT_HEIGHT;

        let circle = this.add.circle(
            width*0.8,
            height - height*0.3,
            60,
            0x888888,
            0.2);
        circle.setStrokeStyle(2,0x000000);

        this.jumpButton = {};
        this.jumpButton.isDown = false;

        let jumpRect: GameObjects.Arc = circle;

        jumpRect
            .setOrigin(0, 0)
            .setScrollFactor(0)
            .setInteractive()
            .on("pointerdown", (pointer) => this.jumpButton.isDown = true)
            .on("pointerup", (pointer) => this.jumpButton.isDown = false);

        jumpRect.setDepth(2);
    }

    private buildMobileControls(): void
    {
        this.createVirtualJoystick();
        this.createMobileJumpButton();

    }

    public isMobile(): boolean {
        return this.sys.game.device.input.touch && window.innerWidth <= Constants.MAX_MOBILE_WIDTH;
    }

    private checkForMobile(): void {

        if (!this.isMobile()) {
            console.log("Loading on desktop");
            this.cursors = this.input.keyboard.createCursorKeys();
            this.jumpButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        }

        else {
            console.log("Loading on mobile device");
            this.buildMobileControls();
        }
    }

    public preload(): void
    {
        let loadingImage: Physics.Arcade.Sprite;
        let loadingAnimationSprite: Physics.Arcade.Sprite;
        this.loadingAnimation.generateFrames();

        this.load.on("start", () => {

            console.log("Start loading assets");
            loadingImage = this.physics.add.sprite(Constants.DEFAULT_WIDTH/2, Constants.DEFAULT_HEIGHT/2, "loadingText");
            loadingImage.setDisplaySize(loadingImage.width/2, loadingImage.height/2);
            loadingAnimationSprite = this.physics.add.sprite(Constants.DEFAULT_WIDTH/2, Constants.DEFAULT_HEIGHT/2, "");
            loadingAnimationSprite.anims.play("loadingAnimation");

        }, this);


        this.load.on("complete", () => {

            console.log("Finished loading assets");
            loadingAnimationSprite.anims.stop();
            loadingImage.destroy();
            loadingAnimationSprite.destroy();

        }, this);

        this.load.tilemapTiledJSON('city', 'assets/tilemaps/city.json');
        this.map.loadImages();
        this.load.image(this.DUDE, 'assets/dude/rot/rot_1.png');
        this.dudeAnimation.loadImages();
        this.load.image('airplane','assets/elements/airplane.png');
        this.load.image("startButton", "assets/elements/start_button.png");
        this.load.image('cornerCardLogo', "assets/elements/cornerCardLogo.png");
        this.Sounds = new Audio(this, this.game);
        this.Sounds.loadAudio();
        this.Sounds.loadIcons();
        //la function cambia la path generica, caricare per ultimo
        this.coin.loadImages();

    }

    public create(): void
    {
        let that = this; // faccio copia del riferimento per usare 'this' dentro le funzioni anonime

        if (!this.createStarted) {

            let hintText = this.add.text(Constants.DEFAULT_WIDTH / 2, Constants.DEFAULT_HEIGHT*0.3, "Press Start to Play",
                {font: '50px font1', fill: '#FFFFFF'});

            let startButton = this.physics.add.sprite(Constants.DEFAULT_WIDTH*0.5, Constants.DEFAULT_HEIGHT*0.5, "startButton");
            startButton.setDisplaySize(170, 170);
            startButton.setInteractive();

            let jumpInstruction: Physics.Arcade.Sprite;
            let cursorInstruction: Physics.Arcade.Sprite;

            if (!this.isMobile()) {
                jumpInstruction = this.physics.add.sprite(Constants.DEFAULT_WIDTH*0.35, Constants.DEFAULT_HEIGHT*0.8, "jumpInstructions");
                jumpInstruction.setDisplaySize(jumpInstruction.width/1.5, jumpInstruction.height/2);

                cursorInstruction = this.physics.add.sprite(Constants.DEFAULT_WIDTH*0.75, Constants.DEFAULT_HEIGHT*0.8, "cursorInstructions");
            }
            else {
                jumpInstruction = this.physics.add.sprite(Constants.DEFAULT_WIDTH*0.90, Constants.DEFAULT_HEIGHT*0.8, "jumpInstructions");
                cursorInstruction = this.physics.add.sprite(Constants.DEFAULT_WIDTH*0.20, Constants.DEFAULT_HEIGHT*0.8, "cursorInstructions");
            }


            // metti le istruzioni e poi distruggele nel pointerdown
  
            hintText.setAlign('right');
            hintText.setDisplayOrigin(hintText.width - hintText.width / 2, hintText.height);

            startButton.once('pointerdown',  () => {
                that.createStarted = true;
                startButton.destroy();
                jumpInstruction.destroy();
                cursorInstruction.destroy();
                that.create();

            }, this);
        }

        if (this.createStarted) {

            let map = this.make.tilemap({key: "city"});
            this.map.createMap(map);
            this.coinLayer = map.getObjectLayer('coinlayer');
            this.flagLayer = map.getObjectLayer('flag');
            this.linesLayer = map.getObjectLayer('lines');

            let lineObjects: Array<Types.Tilemaps.TiledObject> = this.linesLayer.objects;
            let coinObjects: Array<Types.Tilemaps.TiledObject> = this.coinLayer.objects;

            this.coin.generateFrames();

            this.coins = this.physics.add.staticGroup();

            //this is how we actually render our coin object with coin asset we loaded into our game in the preload function
            coinObjects.forEach(coin => {
                let coinSprite: Physics.Arcade.Sprite = this.coins.create(coin.x, coin.y, "coin_1");
                coinSprite.setVisible(coin.visible);
                coinSprite.anims.play('coin');
            });

            let linesGroup = this.physics.add.staticGroup();

            lineObjects.forEach(line => {
                let lineSprite: Physics.Arcade.Sprite = linesGroup.create(line.x, line.y, "lines");
                lineSprite.setAngle(line.rotation);
                lineSprite.setDisplaySize(line.width, 0);
                lineSprite.setVisible(line.visible);
                this.linesArray.push(lineSprite);
            });

            let graphics = this.add.graphics();
            //audioIcon
            this.Sounds.addIcons();

            this.Sounds.iconSoundOn.on('pointerup', function () {
                that.Sounds.manageAudio();
            }, this);
            this.Sounds.iconSoundOff.on('pointerup', function () {
                that.Sounds.manageAudio();
            }, this);


            //score number
            this.scoreTextObj = this.add.text(0, 0, String(this.score),
                {fontFamily: '"font1"', fontSize: "50px", fill: "#000000"});
            this.scoreTextObj.setPosition(90, 45);
            this.scoreTextObj.setScrollFactor(0, 0);
            this.scoreTextObj.setDepth(2);
            

            // score coin
            let coinScore = this.add.sprite(50,67,'coinScore');
            coinScore.play('coinScore');
            coinScore.setScrollFactor(0, 0);
            coinScore.setDepth(2);

            // create won and end messages
            this.initializeWonMessage();
            this.initializeEndMessage();

            this.dudeAnimation.generateFrames();
            
            // sprites
            this.dude = this.physics.add.sprite(Constants.DEFAULT_WIDTH/2, 200, this.DUDE);
            this.dude.setDepth(2); // davanti agli altri oggetti

            /**
             * creo come sprite la bandiera che dovrà comparire dietro alla banca
             */
            this.flag = this.physics.add.sprite(this.flagLayer.objects[0].x, this.flagLayer.objects[0].y, 'flag');

            // dude
            let dudeBody = <Physics.Arcade.Body>this.dude.body;
            dudeBody.setCollideWorldBounds(true);

            this.physics.world.setBounds(0, 0, Constants.GAME_WIDTH, Constants.GAME_HEIGHT);

            // collisions with floor of layers
            this.map.setCollision();

            // collisions between dude and buildings
            this.physics.add.collider(this.dude, this.map.layerBuildings);

            // overlap between dude and coin
            this.physics.add.overlap(this.dude, this.coins, this.onCollectCoin, null, this);

            //sounds
            this.Sounds.addSound();
            this.Sounds.soundTrack.play();

            // aereo e moneta sopra aereo
            let path: Curves.Path = new Curves.Path(4000, 185).lineTo(9000, -200);
            let path2: Curves.Path = new Curves.Path(4000, 135).lineTo(9000, -200);

            graphics.lineStyle(1, 0xDC143C, 0);
            path.draw(graphics, 50);
            path2.draw(graphics, 50);
            this.coinAirplane = this.add.follower(path2, 4000, 135, 'coinAirplane');
            this.coinAirplane.setAlpha(0);
            this.physics.add.collider(this.dude, this.coinAirplane, this.onCollectCoin, null, this);
            this.airplane = this.add.follower(path, 4000, 185, 'airplane');
            this.airplane.setAlpha(0);
            this.checkForMobile(); // dopo la creazione di dude

            //camera
            this.cameras.main.setRoundPixels(true);
            this.cameras.main.setBounds(0, 0, Constants.GAME_WIDTH, Constants.GAME_HEIGHT, false);
            this.cameras.main.startFollow(this.dude);
            this.cameras.main.setBackgroundColor("#ADD8E6");

            this.updateStarted = true;
        }
    }

    private checkArrowsPressed(): boolean
    {
        if (this.cursors.down.isDown || this.cursors.up.isDown || this.cursors.left.isDown || this.cursors.right.isDown)
            return true;
        
        return false;
    }

    private onCollectCoin(dude: Physics.Arcade.Sprite, coin: Physics.Arcade.Sprite): void
    {
        this.jumpButton.isDown = false;
        this.sound.play('coinSound');
        coin.anims.play('solarCoin', true);
        coin.body.enable = false;
        coin.once('animationcomplete', function () {
            coin.destroy();
        }, this);
        this.score++;
        this.scoreTextObj.setText(String(this.score));
    }

    private checkOnOverlapLadder(playerBody: Physics.Arcade.Body, ladder: Tilemaps.Tile): void
    {
        ladder = this.map.layerLadder.getTileAtWorldXY(this.dude.x, this.dude.y + this.dude.height/2);

        if (ladder != null && ladder.layer.name === 'ladderLayer')
            this.onLadder = true;
    }

    private whileOnTopLadder(playerBody: Physics.Arcade.Body, move: number): void
    {
        console.log("Finally I'm on top ladder!!!");
        this.cursors.up.isDown = false;

        if (this.cursors.down.isDown)
            playerBody.y += move;
        else if (this.cursors.left.isDown) {
            this.dude.anims.play("walkLeft", true); 
            playerBody.x -= move*2;
        }
        else if (this.cursors.right.isDown) {
            this.dude.anims.play("walkRight", true);
            playerBody.x += move*2;
        }
        else
            this.dude.anims.play("stayAnimation", true);

    }

    private onOverlapLadder(playerBody: Physics.Arcade.Body): void
    {
        playerBody.setVelocityY(0);
        playerBody.setGravityY(0);

        let move: number = 2;

        let topLadderLayer: Tilemaps.Tile = this.map.layerTopLadder.getTileAtWorldXY(this.dude.x, this.dude.y + this.dude.height/2);

        if (topLadderLayer && playerBody.bottom >= topLadderLayer.getTop() && playerBody.bottom <= topLadderLayer.getTop() + 1)
            this.whileOnTopLadder(playerBody, move);
        else {
            if (this.checkArrowsPressed()) {
                this.dude.anims.play("upAnimation", true);
                if (!this.Sounds.ladderSound.isPlaying)
                    this.Sounds.ladderSound.play();
            }
            else {
                this.dude.anims.play("backImage", true);
                this.Sounds.ladderSound.stop();
            }
            
            if (this.cursors.up.isDown)
                this.moveDude(playerBody, Directions.UP);

            if (this.cursors.down.isDown)
                this.moveDude(playerBody, Directions.DOWN);

            if (this.cursors.left.isDown)
                this.moveDude(playerBody, Directions.LEFT);

            if (this.cursors.right.isDown)
                this.moveDude(playerBody, Directions.RIGHT);
        }

    }

    private checkOnOverlapDoor(door: Tilemaps.Tile): void
    {
        door = this.map.layerDoorEnd.getTileAtWorldXY(this.dude.x, this.dude.y);

        if (door != null && door.layer.name == 'doorEnd')
            this.onDoor = true;

    }

    private onOverlapDoor(playerBody: Physics.Arcade.Body): void
    {
        let flagUp: boolean = false;

        /**
         * rimango fermo sul lato destro appena tocco la porta
         */
        playerBody.setVelocity(0);      
        this.dude.anims.play('sideRightImage', true);

        /**
         * interrompo qualsiasi suono per sottolineare la fine del gioco
         */
        this.Sounds.jumpSound.stop();
        this.Sounds.soundTrack.stop();

        /**
         * se sono state prese tutte le monete rendiamo visibile la scritta
         * di vittoria (una sola volta, con la condizione del timeLines)
         */
        if (this.hasWonGame() && this.timeLines === 0)
        {
            this.timer += 1;
            if ((this.timer % 30 == 0 || this.timer < 30) && this.wonMsg.visible == false)
            {
                this.wonMsg.setVisible(true);
            }
            if (this.timer == 30 || this.timer == 90 ) {
                this.wonMsg.setVisible(false);
            }
        }

        /**
         * si alza la bandiera finchè non si trova sopra il palazzo
         */
        if (!flagUp && this.flag.y > 425)
            this.flag.y -= 1;
        else
            flagUp = true;

        /**
         * se la bandiera è alzata allora parte l'animazione finale con il suono della vittoria
         */
        if (flagUp && this.timeLines <= 4)
        {
            if (!this.Sounds.victorySound.isPlaying  && this.timeLines === 0)
            {
                this.Sounds.victorySound.play();
                this.time.addEvent({delay: 5000, callback: this.onEvent});
            }
            this.linesAnim();
        }

        /**
         * una volta scomparse le linee rosse e la scritta di vittoria (se esiste),
         * compare la scritta finale.
         * Infine incrementiamo timeLines così non viene rieseguito questo blocco
         */
        if (this.timeLines === 5) {
            this.showEndMessage();
            this.timeLines++;
        }

    }

    /**
     * evento di chiusura del gioco (ancora da implementare)
     */
    private onEvent (): void
    {
        let quitButton = document.getElementById('quitGame');
        quitButton.click();
    }

    /**
     * animazione delle linee rosse sulla bandiera
     */
    private linesAnim(): void
    {
        if (this.timeLines === 4)
        {
            this.linesArray.forEach( line => {
                line.destroy();
            });
            if (this.hasWonGame())
                this.wonMsg.setVisible(false);  //lo faccio scomparire

            this.timeLines++;
        }

        if (this.timeLines === 1 || this.timeLines === 3)
        {
            if (this.linesArray[1].displayHeight > 0)
            {
                this.linesArray.forEach( line => {
                    line.displayHeight -= 4;
                });
            }
            else
                this.timeLines++;
        }
        else 
        {
            if (this.linesArray[1].displayHeight < 70) 
            {
                this.linesArray.forEach( line => {
                    line.displayHeight += 3;
                });
            }
            else
                this.timeLines++;
        }
    }

    /**
     * Restituisce true se sono state prese tutte le monete compresa quella
     * sull'aereo (il +1), altrimenti false
     */
    private hasWonGame(): boolean {
        if (this.coinLayer) {
            return (this.coinLayer.objects.length + 1) === this.score;
        }

        return false;
    }

    /**
     * inizializzazione del messaggio di vittoria
     */
    private initializeWonMessage(): void {
        this.wonMsg = this.add.text(Constants.DEFAULT_WIDTH / 3.7, Constants.DEFAULT_HEIGHT*0.2, "CONGRATULATIONS!\nLEVEL COMPLETED",
            {font: '45px font1', fill: '#FDB900'});
        this.wonMsg.setVisible(false);          //inizialmente deve essere invisibile
        this.wonMsg.setScrollFactor(0, 0);
        this.wonMsg.setDepth(1);
    }

    /**
     * inizializzazione del messaggio finale
     */
    private initializeEndMessage(): void {
        this.endMsg = this.physics.add.sprite(Constants.DEFAULT_WIDTH/2, Constants.DEFAULT_HEIGHT/2, 'cornerCardLogo');
        this.endMsg.setScrollFactor(0,0 );
        this.endMsg.setVisible(false);          //inizialmente deve essere invisibile
        this.endMsg.setDepth(4);
    }

    /**
     * visualizzazione del messaggio finale
     */
    private showEndMessage(): void {
        /**
         * creazione di uno sfondo grigio
         */
        let rect: GameObjects.Rectangle = this.add.rectangle();
        rect.setOrigin(0, 0);
        rect.setDisplaySize(Constants.GAME_WIDTH,  Constants.GAME_HEIGHT);
        rect.setFillStyle(0x000000, 0.5);
        rect.setScrollFactor(0, 0);
        rect.setDepth(3);

        /**
         * rendo visibile il messaggio finale
         */
        this.endMsg.setVisible(true);

    }

    private moveDude(playerBody: Physics.Arcade.Body, direction: Directions): void
    {
        switch(direction) {
            case Directions.UP:
                playerBody.y -= 3;
                //playerBody.setVelocityY(-Constants.DUDE_Y_VELOCITY);
                break;
            case Directions.DOWN:
                playerBody.y +=3;
                //playerBody.setVelocityY(Constants.DUDE_Y_VELOCITY);
                break;
            case Directions.LEFT:
                playerBody.setVelocityX(-Constants.DUDE_X_VELOCITY);
                break;
            case Directions.RIGHT:
                playerBody.setVelocityX(Constants.DUDE_X_VELOCITY);
                break;
        }
    }

    private isOnAir(playerBody: Physics.Arcade.Body): boolean
    {
        return !playerBody.onFloor();
    }

    private whileJumping (playerBody: Physics.Arcade.Body, direction: Directions): void
    {
        /**
         * setto la velocità per il salto e faccio partire jumpSound
         */
        if (!this.isOnAir(playerBody))
        {
            this.Sounds.jumpSound.play();
            playerBody.setVelocityY(Constants.JUMP_DISTANCE);
        }

        /**
         * permetto lo spostamento a destra e a sinistra mentre sono in aria,
         * continuando l'animazione jump
         */
        if (direction == Directions.RIGHT || (this.isOnAir(playerBody) && this.cursors.right.isDown) )
        {
            this.dude.anims.play("jumpAnimationRight", true);
            //this.moveDude(playerBody, Directions.RIGHT);
        }
        
        if (direction == Directions.LEFT || (this.isOnAir(playerBody) && this.cursors.left.isDown) )
        { 
            this.dude.anims.play("jumpAnimationLeft", true);
            //this.moveDude(playerBody, Directions.LEFT);
        }
    }

    private whileNotMoving (playerBody: Physics.Arcade.Body): void
    {
        /**
         * se viene premuto space o se mi trovo in aria faccio animazione jump to right
         * altrimenti faccio animazione stay to right
         */
        if (this.jumpButton.isDown || this.isOnAir(playerBody))
            this.whileJumping(playerBody, Directions.RIGHT);
        else
            this.dude.anims.play("stayAnimation", true);
            
    }

    private whileOnSurface (playerBody: Physics.Arcade.Body): void
    {

        playerBody.setGravityY(Constants.GRAVITY_FORCE);
        
        /**
         * se premo il tasto left
         */
        if (this.cursors.left.isDown) {
            /**
             * se premo space o mi sto spostando a sinistra mentre sono in aria faccio l'animazione jump to left
             */
            if (this.jumpButton.isDown || this.isOnAir(playerBody)) {
                this.whileJumping(playerBody, Directions.LEFT);
                this.moveDude(playerBody, Directions.LEFT);
            }

            /**
            * se sto camminando verso sinistra mi sposto
            * a meno che non stia toccando l'estremo sinistro
            */
            else if (!playerBody.onWall()) 
            {
                this.dude.anims.play("walkLeft", true);        //animazione walk verso destra
                this.moveDude(playerBody, Directions.LEFT);
            }
        }

        /**
         * se premo il tasto right
         */
        else if (this.cursors.right.isDown)
        {
            /**
             * se premo space o mi sto spostando a destra mentre sono in aria faccio l'animazione jump to right
             */
            if (this.jumpButton.isDown || this.isOnAir(playerBody)) {
                this.whileJumping(playerBody, Directions.RIGHT);
                this.moveDude(playerBody, Directions.RIGHT);
            }

            /**
             * se sto camminando verso destra mi sposto
             * a meno che non stia toccando l'estremo destro
             */
            else if (!playerBody.onWall())
            {
                this.dude.anims.play("walkRight", true);        //animazione walk verso destra
                this.moveDude(playerBody, Directions.RIGHT);
            }
        }
        else
            this.whileNotMoving(playerBody);
    }

    private checkAirplaneAnimation(): void
    {
        if (this.dude.x > 4900 && this.dude.x < 5100 && !this.airplaneHasGone)
        {

            this.airplaneHasGone = true;

            if (!this.airplane.isFollowing())
            {
                this.airplane.setAlpha(1);
                this.coinAirplane.setAlpha(1);
                this.coinAirplane.play('coin');
                this.physics.world.enable(this.coinAirplane); // lo sprite di default non ha un physics body
                this.airplane.startFollow({
                    positionOnPath: true,
                    duration: 30000,
                    repeat: 0
                });
                this.coinAirplane.startFollow({
                    positionOnPath: true,
                    duration: 30000,
                    repeat: 0
                });
            }
        }
    }

    public update (): void 
    {

        if (this.updateStarted) 
        {
            let playerBody = <Physics.Arcade.Body>this.dude.body;
            let door: Tilemaps.Tile;
            let ladder: Tilemaps.Tile;

            playerBody.setGravityY(Constants.GRAVITY_FORCE);
            playerBody.setVelocityX(0);

            this.onLadder = false;
            this.onDoor = false;

            /**
             * controllo se mi trovo in determinate coordinate, allora parte l'animazione dell'aereo
             */            
            this.checkAirplaneAnimation();

            /**
             * controllo se incontro una scala, se si onLadder si setta a true
             */
            this.checkOnOverlapLadder(playerBody, ladder);
            
            /**
             * controllo se incontro la porta finale, se si onDoor si setta a true
             */
            this.checkOnOverlapDoor(door);

            /**
             * se salgo su una scala
             */
            if (this.onLadder)
                this.onOverlapLadder(playerBody);
            /**
             * se sono sulla porta
             */
            else if (this.onDoor)
                this.onOverlapDoor(playerBody);



            /**
             * altrimenti
             */
            else 
            {
                /**
                 * se mi sposto/cado dalla scala e ladderSound è in funzione lo interrompo
                 */
                if (this.Sounds.ladderSound.isPlaying)
                    this.Sounds.ladderSound.stop();

                /**
                 * se tocco una superfice
                 */
                this.whileOnSurface(playerBody);
            }
            
        }
    }
}
